<template>
  <header
    class="sticky-top border-bottom shadow-sm"
    :class="{ 'header-float': top }"
  >
    <div class="w-100 px-3">
      <nav class="navbar navbar-expand-lg navbar-light bg-white py-0">
        <!-- the project name -->
        <a
          href="javascript:void(0);"
          @click="linkTo('home')"
          class="navbar-brand ms-3 me-5"
          v-text="project.key"
          v-show="isNotHome"
        />

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <ul
            class="navbar-nav"
            v-show="isNotHome"
          >
            <li
              class="nav-item"
              :class="{active: isDemo}"
            >
              <a
                href="javascript:void(0);"
                class="nav-link p-3"
                @click="linkTo('demo')"
              ><i18n path="common.demoAndDocument" /></a>
            </li>
            <li
              class="nav-item"
              :class="{active: isChangeLog}"
            >
              <a
                href="javascript:void(0);"
                class="nav-link p-3"
                @click="linkTo('log')"
              ><i18n path="common.changeLog" /></a>
            </li>
          </ul>

          <!-- projects and languages -->
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                class="nav-link py-3 px-1"
                v-show="isNotHome"
              ><i18n path="common.project" />：
              </a>
            </li>
            <li
              class="nav-item"
              :class="{'nav-focus': projectFocus}"
            >
              <v-selectmenu
                :data="projectList"
                title="Vue plugins"
                key-field="key"
                show-field="key"
                @show="projectFocus = true"
                @hide="projectFocus = false"
                @values="projectChange"
                :scroll="false"
                :query="false"
                v-model="current"
              >
                <a
                  href="javascript:void(0);"
                  class="nav-link py-3 px-3"
                >
                  {{ current }} <fa-icon icon="angle-down" />
                </a>
              </v-selectmenu>
            </li>
            <li class="nav-item">
              <a
                href="javascript:void(0);"
                class="nav-link py-3 px-1"
              ><i18n path="common.language" />：
              </a>
            </li>
            <li
              class="nav-item"
              :class="{'nav-focus': languageFocus}"
            >
              <v-selectmenu
                :data="languages"
                :title="false"
                type="regular"
                @show="languageFocus = true"
                @hide="languageFocus = false"
              >
                <a
                  href="javascript:void(0);"
                  class="nav-link p-3"
                >
                  <i18n path="common.languageDesc" /> <fa-icon icon="angle-down" />
                </a>
              </v-selectmenu>
            </li>
            <li class="nav-item">
              <a
                :href="github"
                class="nav-link p-3"
                target="_blank"
              >
                <fa-icon
                  :icon="['fab','github']"
                  class="fa-lg"
                /> view on <strong>Github</strong>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <transition name="btn-fade">
        <div
          class="back-to-top"
          v-show="top"
        >
          <button
            class="btn btn-light rounded-circle shadow-sm"
            title="Back to top"
            @click="backToTop"
          >
            <fa-icon :icon="['fas', 'arrow-up']" />
          </button>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
import '@/styles/header.scss'
import { urls, getProjectByKey } from '@/store/urls'
import { keys, languages } from '@/config/constants'
import store from '@/store'

const HOME = 'home'
const DEMO = 'demo'
const LOG = 'log'

export default {
  name: 'Header',
  data () {
    const current = store.state.project
    return {
      current: current?.key ?? keys.Home,
      projectList: urls,
      lang: store.state.language,
      projectFocus: false,
      languageFocus: false,
      languages: this.buildLanguages(),
      top: 0
    }
  },
  computed: {
    isNotHome () {
      return this.project &&
        this.project.key &&
        this.project.key !== keys.Home
    },
    isDemo () {
      return this.$store.state.isDemo
    },
    isChangeLog () {
      return this.$store.state.isChangeLog
    },
    project () {
      return this.$store.state.project
    },
    github () {
      const key = this.project.key !== keys.Home ? this.project.key : ''
      return `https://github.com/TerryZ/${key}`
    }
  },
  watch: {
    lang () {
      this.$store.commit('changeLanguage', this.lang)
    },
    current (val) {
      if (!val) return
      const newProject = getProjectByKey(val)
      if (newProject && Object.keys(newProject).length) {
        this.$store.commit('project', newProject)
        this.$router.push({ path: newProject.home }, () => {
          window.scrollTo(0, 0)
        })
      }
    }
  },
  methods: {
    projectChange (data) {
      // console.log(data)
    },
    buildLanguages () {
      return languages.map(item => {
        return {
          content: item.name,
          callback: () => { this.lang = item.key }
        }
      })
    },
    linkTo (type) {
      if (this.project && Object.keys(this.project).length) {
        switch (type) {
          case HOME:
            this.$router.push({ path: this.project.home })
            break
          case DEMO:
            this.$router.push({ path: this.project.demo })
            break
          case LOG:
            this.$router.push({ path: `/changelog/${this.project.key}` })
            break
        }
      }
    },
    scroll (e) {
      const now = window.scrollY ? 1 : 0
      if (this.top !== now) this.top = now
    },
    backToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scroll)
  }
}
</script>
